import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

export interface AddUserDashboardResponse extends AxiosResponse {
  data: {
    apiStatus: "SUCCESS" | "ERROR"
    message?: string
    errorCode?: number
    errorMessage?: string
  }
}

export interface DeleteUserDashboardRequest
  extends Partial<AxiosRequestConfig> {
  params: {
    userId: number
  }
}

export function deleteUserDashboardsApi(
  { params, ...config }: DeleteUserDashboardRequest,
  axiosInstance: AxiosInstance,
): Promise<AddUserDashboardResponse> {
  return axiosInstance({
    method: "delete",
    url: `newadmin/user-account/${params.userId}`,
    ...config,
  }) as Promise<AddUserDashboardResponse>
}
